import React, { Fragment } from "react";

function Background() {
  return (
    <Fragment>
      <div className="square" id="polygon1"></div>
      <div className="square" id="polygon2"></div>
      <div className="octagon" id="polygon5"></div>
      <div className="octagon" id="polygon6"></div>
    </Fragment>
  );
}

export default Background;
